module.exports = __webpack_public_path__ + "img/slide-prev.1fb1c2f8.svg";